import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { formatCurrency } from './radarUtils';

function Signal({ value }) {
  if (value > 0) return <span className="text-danger-700 font-semibold">↑ {value}%</span>;
  if (value < 0) return <span className="text-success-700 font-semibold">↓ {Math.abs(value)}%</span>;
  return <span className="text-gray-600 font-semibold">0%</span>;
}

const ComparativoPage = () => {
  const [period, setPeriod] = useState('28d');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/radar-lucro/comparativo', {
        params: { period },
      });
      setData(response.data || null);
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao carregar comparativo');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [period]);

  const indicadores = data?.indicadores || {};

  return (
    <div className="animate-fade-in space-y-4">
      <div className="rounded-xl border border-gray-300 bg-gray-50 p-4">
        <p className="text-sm font-semibold text-gray-800">Comparacao de periodos</p>
        <p className="text-sm text-gray-700 mt-1">Setas para cima indicam aumento de risco. Setas para baixo indicam reducao de risco.</p>
      </div>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Comparar Periodos</h1>
          <p className="text-gray-600">Atual x anterior para os principais riscos operacionais</p>
        </div>
        <div className="flex gap-2">
          <select className="form-select" value={period} onChange={(e) => setPeriod(e.target.value)}>
            <option value="28d">28 dias</option>
            <option value="30d">30 dias</option>
            <option value="60d">60 dias</option>
          </select>
          <button className="btn-secondary" onClick={loadData} disabled={loading}>
            Atualizar
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        <div className="card">
          <div className="card-body">
            <p className="text-sm text-gray-500">Risco 7d</p>
            <p className="text-xl font-bold text-gray-900">{formatCurrency(indicadores.risco_7d_total?.atual)}</p>
            <Signal value={indicadores.risco_7d_total?.variacao_pct || 0} />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <p className="text-sm text-gray-500">Capital parado</p>
            <p className="text-xl font-bold text-gray-900">{formatCurrency(indicadores.valor_parado_total?.atual)}</p>
            <Signal value={indicadores.valor_parado_total?.variacao_pct || 0} />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <p className="text-sm text-gray-500">Itens com estoque negativo</p>
            <p className="text-xl font-bold text-gray-900">{indicadores.itens_negativos?.atual || 0}</p>
            <Signal value={indicadores.itens_negativos?.variacao_pct || 0} />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <p className="text-sm text-gray-500">Itens sem preco</p>
            <p className="text-xl font-bold text-gray-900">{indicadores.itens_sem_preco?.atual || 0}</p>
            <Signal value={indicadores.itens_sem_preco?.variacao_pct || 0} />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <p className="text-sm text-gray-500">Produtos criticos em ruptura</p>
            <p className="text-xl font-bold text-gray-900">{indicadores.produtos_criticos_ruptura?.atual || 0}</p>
            <Signal value={indicadores.produtos_criticos_ruptura?.variacao_pct || 0} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparativoPage;
